export function urlJoin(...paths: (string | number)[]): string {
  return paths
    .map((path) => path.toString())
    .map((path) => path.replace(/\/+$/, ''))
    .map((path, idx) => (idx === 0 ? path : path.replace(/^\/+/, '')))
    .filter((path) => path !== '')
    .join('/');
}

export function removeQueryParams(url: string): string {
  try {
    return url.split('?')[0];
  } catch {
    return url;
  }
}
